// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__86sSF","error":"Textarea_error__s2wkr","readonly":"Textarea_readonly__2Djz5","disabled":"Textarea_disabled__2gUrg"};